import React, { useState } from 'react';
import {
  DataContainer,
  DataItem,
  Placeholder,
  InputComp,
  TrashWrapper,
  Trash,
  Error,
  InputWrapper,
  ErrorIcon,
  Plus,
  PlusContainer
} from 'Screens/Contextualization/Manage/components/VulnerabilityDetail/components/Tabs/components/GeneralTab/components/CVE/styled';

const CWE_VALIDATOR = /^CWE-\d+$/i;

const InputCWE = ({ listData, onAdd, onRemove, expanded }) => {
  const [value, setValue] = useState('');
  const [error, setError] = useState(false);
  const isOdd = (n) => n % 2 !== 0;

  const isValid = (v) => CWE_VALIDATOR.test(v.trim());

  const handleAdd = () => {
    const normalized = value.trim().toUpperCase();
    if (!isValid(normalized)) {
      setError(true);
      return;
    }
    onAdd(normalized);
    setValue('');
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') handleAdd();
  };

  const handleChange = (e) => {
    setError(false);
    setValue(e.target.value);
  };

  return (
    <>
      <InputWrapper>
        <InputComp
          value={ value }
          placeholder="CWE-NNN"
          onChange={ handleChange }
          onKeyPress={ handleKeyPress }
        />
        <PlusContainer>
          <Plus onClick={ handleAdd } />
        </PlusContainer>
        {error && (
          <Error>
            <ErrorIcon />
            CWE not valid
          </Error>
        )}
      </InputWrapper>
      <DataContainer showGradient={ listData.length < 3 } expanded={ expanded }>
        {listData.map((name, i) => (
          <DataItem
            key={ `cwe_${name}` }
            isOdd={ isOdd(i) }
          >
            <Placeholder
              href={ `https://cwe.mitre.org/data/definitions/${name.replace(/^CWE-/i, '')}.html` }
              target="_blank"
              rel="noopener noreferrer"
            >
              {name}
            </Placeholder>
            <TrashWrapper onClick={ () => onRemove(name) }>
              <Trash />
            </TrashWrapper>
          </DataItem>
        ))}
      </DataContainer>
    </>
  );
};

export default InputCWE;
